'use client';

import dynamic from 'next/dynamic';

type Slide = { src: string; alt: string };

const CarouselSlider = dynamic(() => import('./CarouselSlider'), { ssr: false });

export default function CarouselWrapper({ slides }: { slides: Slide[] }) {
  return <CarouselSlider slides={slides} />;
}
